import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ReleaseBundleComponent }    from '../release-bundle/release-bundle.component';
import { ReleaseBundleDetailsComponent }  from '../release-bundle-details/release-bundle-details.component';

import { AuthGuard } from '../auth-guard.service';

const bundleRoutes: Routes = [
  { path: 'bundles', redirectTo: '/Release-Bundles' },
  { path: 'bundle/:id', redirectTo: '/Release-Bundles/:id' },
  { path: 'Release-Bundles',  component: ReleaseBundleComponent, canActivate: [AuthGuard]  },
  { path: 'Release-Bundles/:id', component: ReleaseBundleDetailsComponent, canActivate: [AuthGuard]  }
];

@NgModule({
  imports: [
    RouterModule.forChild(bundleRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ReleaseBundleRoutingModule { }